import React from 'react';
import { AppNavigate, AppOutlet } from '@/navigation';
import { AuthService } from '@/auth';
import { ROUTES } from '@/routes';
import { LogoutModal } from '../domain/common/LogoutModal';
import { useAppSelector } from '@/hooks';
import { selectAuth } from '@/auth/store';

export const PrivateRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { willLogout, token, currentKey } = useAppSelector(selectAuth);

  const isAuth =
    token !== null && token !== '' && currentKey !== null && currentKey !== '';

  const onConfirm: React.MouseEventHandler = e => {
    e.preventDefault();
    void new AuthService().logout();
  };

  const onCancel = () => {
    new AuthService().clearWillLogout();
  };

  // Do not gate the private <Outlet/> on application or missing-items loading.
  // Those fetches run from child routes on mount; a full-screen Loader here
  // unmounts the outlet, then remounts when loading finishes, which retriggers
  // the same fetch hooks (fetchRef resets) and causes a remount/fetch loop.

  if (!isAuth) {
    return <AppNavigate to={ROUTES.unauthenticated} replace />;
  }

  return (
    <>
      <LogoutModal
        isOpen={willLogout}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
      {children ?? <AppOutlet />}
    </>
  );
};
